import { Component, OnInit, ViewChild, ElementRef, HostListener, signal, OnDestroy, effect } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { UserDataService } from '../../services/user-data.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { User } from '../../models/user';

@Component({
  selector: 'app-top-bar',
  imports: [TranslatePipe, RouterLink],
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit {

  @ViewChild('menu') menuElement?: ElementRef;
  
  public isMenuActive = false;
  public firstName = signal<string>('');
  public lastName = signal<string>('');
  public userId = signal<number>(0);
  public userEmail = signal<string>('');
  public imgUrl = signal<string>('');

  lang_click = false;
  lang = signal<string>('');
  bikeImage: any;

  public noImg = signal<boolean>(true);
  langUsed: string = '';

  constructor(
    private userDataService: UserDataService,
    private router: Router,
    private translate: TranslateService
  ) {
    effect(() => {
      this.refresh(this.userDataService.user());
    });
  }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe(lang => {
      if (lang.lang === 'en') {
        this.lang.set('English');
      } else {
        this.lang.set('Italiano');
      }
    });
    
    this.userDataService.checkUser().subscribe();
  }

  private refresh(user: User | null) {
    if (user) {
      this.firstName.set(user?.firstName ?? '');
      this.lastName.set(user?.lastName ?? '');
      this.imgUrl.set('https://s3-eu-west-1.amazonaws.com/' + environment.s3PublicBucket + '/' + user?.uid + '/userimage.jpg');
      this.noImg.set(false);
      this.userId.set(user?.id ?? 0);
      this.userEmail.set(user?.email ?? '');
    } else {
      this.firstName.set('');
      this.lastName.set('');
      this.imgUrl.set('');
      this.noImg.set(true);
      this.userId.set(0);
      this.userEmail.set('');
    }
  }
  
  profileClicked() {
    this.lang_click = false;
    if (this.menuElement?.nativeElement.classList.contains('is-active')) {
      this.isMenuActive = false;
    } else {
      this.isMenuActive = true;
    }
  }

  languageClicked() {
    this.lang_click = true;
    if (this.menuElement?.nativeElement.classList.contains('is-active')) {
      this.isMenuActive = false;
    } else {
      this.isMenuActive = true;
    }
  }

  loginClicked() {
    this.router.navigate(['/login']);
    this.isMenuActive = false;
  }

  registerClicked() {
    this.router.navigate(['/register']);
    this.isMenuActive = false;
  }

  logoutClicked() {
    this.userDataService.logout();
    this.router.navigate(['/login']);
    this.isMenuActive = false;
  }

  langClicked(lang: string) {
    if (lang === 'en') {
      this.lang.set('English');
    } else {
      this.lang.set('Italiano');
    }
    this.translate.use(lang);
    this.isMenuActive = false;
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.menuElement?.nativeElement.contains(event.target) && this.menuElement?.nativeElement.classList.contains('is-active')) {
      this.isMenuActive = false;
    }
  }

  updateUrl() {
    this.noImg.set(true);
  }
}
